export default __webpack_public_path__ + "static/media/Armwrap of the Firebrand.252a0b42.jpg";